import { render } from "./UserItems.vue?vue&type=template&id=05de14be&scoped=true"
import script from "./UserItems.vue?vue&type=script&lang=js"
export * from "./UserItems.vue?vue&type=script&lang=js"

import "./UserItems.vue?vue&type=style&index=0&id=05de14be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05de14be"]])

export default __exports__